/*
class to centralize and simplify formatting for social impact scores (number formatting, coloring, etc)
*/
import chroma from 'chroma-js'

function compact(list) {
    return list.filter((obj) => obj);    
}

export function capitalize (str) {
    return str[0].toUpperCase() + str.slice(1)
}

export class SocialScores {
    static legendRange = [100,75,50,25,0]
    // static colorScale = chroma.scale(['#2ca25f','#99d8c9','#e5f5f9']).domain([100,0])
    static colorScale = chroma.scale(chroma.brewer.Viridis).domain([100,0])
    

    static getTextColor(num) {
        return this.colorScale(num)
    }
    static getColor(num) {
        return this.colorScale(num)
    }

    static subscoreTypes = ["social_impact_score","low_affluence_score","low_education_score","low_prestige_employment_score","health_obstacle_score","poverty_concentration_score","pct_income_on_housing_score","minority_score","low_quartile_social_impact_score","top_quartile_social_impact_score"]

    constructor(data) {
        /* data is an object that is assumed to have the following attributes: 
        ["social_impact_score","low_affluence_score","low_education_score","low_prestige_employment_score","health_obstacle_score","poverty_concentration_score","pct_income_on_housing_score","minority_score","low_quartile_social_impact_score","top_quartile_social_impact_score"]
        Extra attributes are fine, just ignored.
        */

        SocialScores.subscoreTypes.forEach(metric => {
            this[`${metric}_unrounded`] = data[metric]
            this[metric] = parseFloat(data[metric]).toFixed(1)
        })
        this.subscores = compact(SocialScores.subscoreTypes.map(type => this[type]))        
        // for abstract interface parity with the risQScores class
        this.total = this.social_impact_score
    }

    isMax(scoreName) {
        return this[scoreName] >= Math.max(...this.subscores)
    }

    toHtml(scoreName) {
        const tag = this.isMax(scoreName) ? 'b' : 'span'
        //return  `<${tag} style="color:${SocialScores.getTextColor(this[scoreName])}">${this[scoreName]}</${tag}>`
        return  `<${tag}>${this[scoreName]}</${tag}>`
    }

    color(scoreName) {        
        return SocialScores.getColor(this[`${scoreName}_score_unrounded`]);
    }
}